import '../styles/submitMobileNumberStyles.css'
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { MdPhone } from "react-icons/md";
import { submitPhoneNumberTitle, actions, campaignDetails, privacyPolicy, iAgree, submitMobileNumberTitle, submitMobileNUmberSuccessMessage } from '../utils/Strings'
import { StyledTextField } from '../utils/Helper'
import { Button, Checkbox, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, InputAdornment, Link, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/Store';
import { resetSubmitMobileNumberState } from '../redux/MobileNumberReducer';
import { setClarityTag } from '../utils/ClarityUtils';
import { CareerNavigatorRequestModel } from '../models/CareerNavigatorRequestModel';
import { submitMobileNumber } from '../hooks/SubmitMobileNumberApiHooks';

import { useLocation } from 'react-router-dom';
import { useStateContext } from '../context/StateContext';


const SubmitMobileNumber = () => {

    const [isNumberError, setNumberError] = React.useState(false)
    const [mobileNumber, setMobileNumber] = React.useState('')
    const [showErrorDialog, setShowErrorDialog] = React.useState(false)
    const [showSuccessDialog, setShowSuccessDialog] = React.useState(false)
    const [isCheckboxChecked, setCheckboxChecked] = React.useState(false)
    const [isTermsChecked, setTermsChecked] = React.useState(false)

    const { loading, error, requestResponse } = useSelector((state: RootState) => state.submitMobileNumber);
    const dispatch = useDispatch();

    const location = useLocation();
    const screenContext = location.state?.from
    const { selectedState } = useStateContext();

    React.useEffect(() => {
        setClarityTag('page', 'Submit Mobile Number');
        dispatch(resetSubmitMobileNumberState())
    }, [])

    React.useEffect(() => {
        if (error !== undefined) {
            setShowErrorDialog(true)
        }
    }, [error])

    React.useEffect(() => {
        if (requestResponse) {
            setShowSuccessDialog(true)
        }
    }, [requestResponse])

    function onMobileNumberSubmit() {
        if (isCheckboxChecked == true) {
            if (mobileNumber.length === 10 && mobileNumber.match(/^[0-9]+$/)) {
                const careerNavigatorRequest: CareerNavigatorRequestModel = { phone: mobileNumber, context: screenContext, type: 'sms', id: 0, name: '', email: '', message: '', stateId: selectedState?.id }
                submitMobileNumber(dispatch, careerNavigatorRequest)
            } else {
                setNumberError(true)
            }
        }
    }

    return (
        <div>
            {requestResponse ? showSuccessMessage() : renderForm()}
            {showErrorMessage()}
        </div>
    );

    function renderForm() {
        return (
            <div className='submit-mobile-number-container'>

                <div className='submit-mobilenumber-title'>{submitMobileNumberTitle}</div>
                <div className='submit-phonenumber-title'>{submitPhoneNumberTitle}</div>

                <StyledTextField
                    id="outlined-basic-name"
                    label="Mobile Number"
                    variant="outlined"
                    required
                    autoComplete='off'
                    value={mobileNumber}
                    inputMode='text'
                    error={isNumberError}
                    helperText={isNumberError ? 'Please enter a valid mobile number' : ''}
                    onChange={(e) => {
                        setMobileNumber(e.target.value)
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <MdPhone color='#094f98' size={22} />
                            </InputAdornment>
                        )
                    }}
                />

                <FormControlLabel control={<Checkbox color='primary' style={{ color: '#094f98' }} onChange={onCheckboxChange} checked={isCheckboxChecked} />} label={<Typography style={{ fontFamily: 'nunito_regular', fontSize: '18px', color: '#094f98', textAlign: 'left' }}>{campaignDetails}</Typography>} />

                <FormControlLabel
                    control={
                        <Checkbox
                            color='primary'
                            style={{ color: '#094f98' }}
                            onChange={onTermsCheckboxChange}
                            checked={isTermsChecked}
                        />
                    }
                    label={
                        <Typography style={{ fontFamily: 'nunito_regular', fontSize: '18px', color: '#094f98' }}>
                            {iAgree}{" "}
                            <Link href="https://www.goodwillde.org/privacy-policy-2/" target="_blank" rel="noopener" style={{ color: '#094f98', fontFamily: "nunito_bold" }}>
                                {privacyPolicy}
                            </Link>
                        </Typography>
                    }
                />

                <div className={isCheckboxChecked == true && isTermsChecked == true ? 'mobilenumber-submit-button' : 'mobilenumber-submit-button-disabled'} onClick={onMobileNumberSubmit}>
                    {loading === true && <CircularProgress size={22} color='inherit' style={{ alignSelf: 'center', marginRight: '6px' }} />}
                    <div>{actions.submit}</div>
                </div>
            </div>
        )
    }

    function onCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
        setCheckboxChecked(event.target.checked)
    }

    function onTermsCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
        setTermsChecked(event.target.checked)
    }

    function showSuccessMessage() {
        return (
            <Dialog
                onClose={clearErrorState}
                open={showSuccessDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {submitMobileNumberTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {submitMobileNUmberSuccessMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onSuccessDialogClose}>OK</Button>
                </DialogActions>
            </Dialog>
        )
    }

    function onSuccessDialogClose() {
        setShowSuccessDialog(false)
        resetForm()
        dispatch(resetSubmitMobileNumberState())
    }

    function showErrorMessage() {
        return (
            <Dialog
                onClose={clearErrorState}
                open={showErrorDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Submission Failed"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {error ? error?.errorMessage : 'Something went wrong while submitting your request. Please try again later.'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={clearErrorState}>OK</Button>
                </DialogActions>
            </Dialog>
        )
    }

    function clearErrorState() {
        setShowErrorDialog(false)
        resetForm()
        if (error?.operation == 'SUBMIT_MOBILE_NUMBER') {
            dispatch(resetSubmitMobileNumberState())
        }
    }

    function resetForm() {
        setMobileNumber('')
        setCheckboxChecked(false)
        setTermsChecked(false)
        setNumberError(false)
    }
}

export default SubmitMobileNumber;